export default __webpack_public_path__ + "static/food-selection-8fa903103e7e6b10990755dcda80de1d.jpeg";